const InstagramIcon = (props: { className?: string }) => {
  const { className } = props;

  return (
    <svg className={className} fill="currentColor" width="100%" height="100%" viewBox="0 0 16 16">
      <path d="M2.055 0.001h11.892c1.128 0 2.053 0.924 2.053 2.055v11.889c0 1.131-0.924 2.055-2.053 2.055h-11.892c-1.13 0-2.055-0.924-2.055-2.055v-11.889c0-1.131 0.925-2.055 2.055-2.055zM11.657 1.777c-0.398 0-0.722 0.325-0.722 0.722v1.725c0 0.395 0.324 0.719 0.722 0.719h1.807c0.398 0 0.72-0.325 0.72-0.719v-1.725c0-0.396-0.322-0.722-0.72-0.722h-1.807zM14.191 6.767h-1.406c0.131 0.435 0.205 0.896 0.205 1.374 0 2.66-2.228 4.819-4.974 4.819s-4.974-2.159-4.974-4.819c0-0.479 0.071-0.939 0.206-1.374h-1.468v6.756c0 0.354 0.286 0.639 0.635 0.639h11.141c0.351 0 0.635-0.285 0.635-0.639v-6.756zM8.015 4.853c-1.775 0-3.213 1.394-3.213 3.113s1.438 3.114 3.213 3.114 3.213-1.396 3.213-3.114c0.001-1.72-1.438-3.113-3.213-3.113z" />
    </svg>
  );
};

export default InstagramIcon;
